import { alpha } from '@material-ui/core/styles';

// ----------------------------------------------------------------------

function createGradient(color1, color2) {
  return `linear-gradient(to bottom, ${color1}, ${color2})`;
}

// SETUP COLORS
const GREY = {
  0: '#FFFFFF',
  100: '#F9FAFB',
  200: '#F4F6F8',
  300: '#DFE3E8',
  400: '#C4CDD5',
  500: '#919EAB',
  600: '#637381',
  700: '#454F5B',
  800: '#212B36',
  900: '#161C24',
  500_8: alpha('#919EAB', 0.08),
  500_12: alpha('#919EAB', 0.12),
  500_16: alpha('#919EAB', 0.16),
  500_24: alpha('#919EAB', 0.24),
  500_32: alpha('#919EAB', 0.32),
  500_48: alpha('#919EAB', 0.48),
  500_56: alpha('#919EAB', 0.56),
  500_80: alpha('#919EAB', 0.8)
};

// const PRIMARY = {
//   lighter: '#C8FACD',
//   light: '#5BE584',
//   main: '#00AB55',
//   dark: '#007B55',
//   darker: '#005249',
//   contrastText: '#fff'
// };
// YELLOW
// const PRIMARY = {
//   lighter: '#C8FACD',
//   light: '#ffa175',
//   main: '#ff6f48',
//   dark: '#c63e1d',
//   darker: '#005249',
//   contrastText: '#fff'
// };
// // VIOLET/YELLOW-RED
const PRIMARY = {
  lighter: '#C8FACD',
  light: '#ff597a',
  main: '#f5004e',
  dark: '#ba0027',
  darker: '#005249',
  contrastText: '#fff'
};
// // VIOLET
// const PRIMARY = {
//   lighter: '#C8FACD',
//   light: '#ff61ad',
//   main: '#cc277e',
//   dark: '#960052',
//   darker: '#005249',
//   contrastText: '#fff'
// };
// // RED
// const PRIMARY = {
//   lighter: '#C8FACD',
//   light: '#ff6b81',
//   main: '#f52f55',
//   dark: '#bb002d',
//   darker: '#005249',
//   contrastText: '#fff'
// };
// // LANDING PAGE BLUE
// const PRIMARY = {
//   lighter: '#C8FACD',
//   light: '#373f5c',
//   main: '#0e1932',
//   dark: '#00000c',
//   darker: '#005249',
//   contrastText: '#fff'
// };
// // LIGHT-BLUE
// const PRIMARY = {
//   lighter: '#C8FACD',
//   light: '#c7dfff',
//   main: '#95add2',
//   dark: '#667ea1',
//   darker: '#005249',
//   contrastText: '#fff'
// };
const SECONDARY = {
  lighter: '#D6E4FF',
  light: '#c7dfff',
  main: '#95add2',
  dark: '#667ea1',
  darker: '#091A7A',
  contrastText: '#fff'
};
const INFO = {
  lighter: '#D0F2FF',
  light: '#74CAFF',
  main: '#1890FF',
  dark: '#0C53B7',
  darker: '#04297A',
  contrastText: '#fff'
};
const SUCCESS = {
  lighter: '#E9FCD4',
  light: '#AAF27F',
  main: '#54D62C',
  dark: '#229A16',
  darker: '#08660D',
  contrastText: GREY[800]
};
const WARNING = {
  lighter: '#FFF7CD',
  light: '#FFE16A',
  main: '#FFC107',
  dark: '#B78103',
  darker: '#7A4F01',
  contrastText: GREY[800]
};
const ERROR = {
  lighter: '#FFE7D9',
  light: '#FFA48D',
  main: '#FF4842',
  dark: '#B72136',
  darker: '#7A0C2E',
  contrastText: '#fff'
};

const GRADIENTS = {
  primary: createGradient(PRIMARY.light, PRIMARY.main),
  info: createGradient(INFO.light, INFO.main),
  success: createGradient(SUCCESS.light, SUCCESS.main),
  warning: createGradient(WARNING.light, WARNING.main),
  error: createGradient(ERROR.light, ERROR.main)
};

const palette = {
  common: { black: '#000', white: '#fff' },
  primary: { ...PRIMARY },
  secondary: { ...SECONDARY },
  info: { ...INFO },
  success: { ...SUCCESS },
  warning: { ...WARNING },
  error: { ...ERROR },
  grey: GREY,
  gradients: GRADIENTS,
  divider: GREY[500_24],
  text: { primary: GREY[800], secondary: GREY[600], disabled: GREY[500] },
  background: { paper: '#fff', default: '#fff', neutral: GREY[200] },
  action: {
    active: GREY[600],
    hover: GREY[500_8],
    selected: GREY[500_16],
    disabled: GREY[500_80],
    disabledBackground: GREY[500_24],
    focus: GREY[500_24],
    hoverOpacity: 0.08,
    disabledOpacity: 0.48
  }
};

export default palette;
